export default {
  OptionList: "/tcs/template-management/dropdown",
};
